import { MenuItemCommandEvent } from 'primeng/api';
import { MenuItemWithId } from "./menu-items.provider";

export const menuItems: MenuItemWithId[] = [
  {
    label: 'Learning Path',
    id: 'LEARNING_PATH',
    items: [
      {
        label: 'Roadmaps',
        id: 'ROADMAPS',
        icon: 'pi pi-fw pi-book',
        routerLink: ['/roadmaps'],
      }
    ],
  },
];
